import { render, staticRenderFns } from "./profileNotifications.vue?vue&type=template&id=235c4de6&scoped=true&"
import script from "./profileNotifications.vue?vue&type=script&lang=js&"
export * from "./profileNotifications.vue?vue&type=script&lang=js&"
import style0 from "./profileNotifications.vue?vue&type=style&index=0&id=235c4de6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235c4de6",
  null
  
)

export default component.exports